import cloneDeep from 'lodash.clonedeep';
import type { BaseAction } from '../../../@types/actions';
import validationMethods from './validationMethods';

export interface CreateAssignmentValidation {
  registration_number: boolean;
  odometerReadingValue: boolean;
}

export interface CreateAssignment {
  registration_number: string;
  odometerReadingValue: number | null;
}

export interface CreateAssignmentState {
  value: CreateAssignment;
  validation: CreateAssignmentValidation;
  interact: CreateAssignmentValidation;
}

export const initialState = (assignmentInit?: CreateAssignment): CreateAssignmentState => {
  const assignment = cloneDeep({
    registration_number: assignmentInit?.registration_number || '',
    odometerReadingValue: assignmentInit?.odometerReadingValue || null,
  });

  return {
    value: {
      ...assignment,
    },
    validation: {
      registration_number: validationMethods.registration_number(assignment?.registration_number),
      odometerReadingValue: validationMethods.odometerReadingValue(
        assignment?.odometerReadingValue,
      ),
    },
    interact: {
      registration_number: false,
      odometerReadingValue: false,
    },
  };
};

export const RESET = 'RESET';
export type RESET_TYPE = BaseAction<typeof RESET>;

export const SET_CHANGE = 'SET_CHANGE';
export type SET_CHANGE_TYPE = BaseAction<typeof SET_CHANGE> & {
  name: 'registration_number';
  value?: string;
};

export const SET_BLUR = 'SET_BLUR';
export type SET_BLUR_TYPE = BaseAction<typeof SET_BLUR> & {
  name: 'registration_number';
};

export const SET_CHANGE_NUMBER = 'SET_CHANGE_NUMBER';
export type SET_CHANGE_NUMBER_TYPE = BaseAction<typeof SET_CHANGE_NUMBER> & {
  name: 'odometerReadingValue';
  value: number | null;
};

export const SET_BLUR_NUMBER = 'SET_BLUR_NUMBER';
export type SET_BLUR_NUMBER_TYPE = BaseAction<typeof SET_BLUR_NUMBER> & {
  name: 'odometerReadingValue';
};

export const SET_VALIDATE_EVERYTHING = 'SET_VALIDATE_EVERYTHING';
export type SET_VALIDATE_EVERYTHING_TYPE = BaseAction<typeof SET_VALIDATE_EVERYTHING>;

export type CreateNewCampaignAction =
  | SET_CHANGE_TYPE
  | SET_BLUR_TYPE
  | SET_CHANGE_NUMBER_TYPE
  | SET_BLUR_NUMBER_TYPE
  | SET_VALIDATE_EVERYTHING_TYPE
  | RESET_TYPE;

const reducer = (state: CreateAssignmentState, action: CreateNewCampaignAction) => {
  const next = cloneDeep(state);
  switch (action.type) {
    case SET_CHANGE:
      next.value[action.name] = action.value || '';
      next.validation[action.name] = validationMethods[action.name](action.value);
      return next;

    case SET_BLUR:
      next.validation[action.name] = validationMethods[action.name](next.value[action.name]);
      next.interact[action.name] = true;
      return next;

    case SET_BLUR_NUMBER:
      next.value[action.name] = next.value[action.name]?.toString()?.length
        ? Number.parseInt(next.value[action.name]?.toString() || '0', 10)
        : 0;
      next.validation[action.name] = validationMethods[action.name](next.value[action.name]);
      next.interact[action.name] = true;
      return next;

    case SET_CHANGE_NUMBER:
      next.value[action.name] = action.value;
      next.validation[action.name] = validationMethods[action.name](action.value);
      return next;

    case RESET:
      return initialState();

    case SET_VALIDATE_EVERYTHING:
      next.validation.registration_number = validationMethods.registration_number(
        next.value.registration_number,
      );
      next.interact.registration_number = true;

      next.validation.odometerReadingValue = validationMethods.odometerReadingValue(
        next.value.odometerReadingValue,
      );
      next.interact.odometerReadingValue = true;

      return next;
    default:
      throw new Error('createNewCampaignReducer unsupported action type');
  }
};

export default reducer;
